import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { Tools } from '@service/tools';
import { RequestTools } from '@service/request.tools';
import { EditorService } from '@service/editor.service';
import { RightService } from '@service/right.service';
import { forkJoin, lastValueFrom } from 'rxjs';
import { FormatRequestTools } from '@service/formatrequest.tools';
import { TranslateService } from '@ngx-translate/core';
import {LoadingService} from "@core/_services/loading.service";
import { TokenService } from '@core/_services/token.service';
import { CheckTools } from '@service/check.tools';

@Component({
    selector: 'deletedocs',
    templateUrl: 'deletedocs.component.html',
    styleUrls: ['deletedocs.component.scss'],
})
export class DeleteDocsComponent implements OnInit, OnChanges {
    @Input() public actionGroup;
    @Input() public selectedDocs;
    @Input() public titleDelete;
    @Input() public currentSelectedBsk;
    @Input() public bskMode;
    @Input() public isAdmin;
    @Input() public docBasket;

    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onCloseIndex: EventEmitter<any> = new EventEmitter();
    @Output()
    public onCloseDialog: EventEmitter<any> = new EventEmitter();

    @Output()
    public onClickDeleteDoc: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public archivDelete: boolean = true;
    private successList: any[];
    private failList: any[];
    private docBasketList: any[];


    constructor(
        protected _messageService: MessagesService,
        private requestTools: RequestTools,
        public tools: Tools,
        public editorService: EditorService,
        private rightService: RightService,
        private formatRequestTools: FormatRequestTools,
        private translate: TranslateService,
        private loadingService: LoadingService,
        private tokenService: TokenService,
        private checkTools: CheckTools
    ) {
        this.successList = new Array();
        this.failList = new Array();
        this.docBasketList = new Array();
    }

    public ngOnInit() {
    }

    public ngOnChanges() {}

    public endDeleteDoc(aParam) {
        this.onClickDeleteDoc.emit(aParam);
    }

    public closeIndex(event) {
        this.onCloseIndex.emit(event);
    }

    public closeDialog(event) {
        this.onCloseDialog.emit(event);
    }

    public clickDelDoc() {
        if (this.actionGroup === true) {
            this.getBasketDoc();
        } else {
            this.verifyDel();
        }
    }

    private async getBasketDoc() {
        let wRequest = [];
        let wRes: any;
        this.docBasketList = [];
        this.loadingService.initProgressBar(this.selectedDocs.length, 4)
        for (const item of this.selectedDocs) {
            this.requestTools.setCurrentDocId(item.doc_docid);
            wRequest.push(this.requestTools.getBasketsDocWithId());
        }
        // Récup des docs avec leur bannette associée sous forme de tableau avec statut erreur individuel
        // Si pas de tableau : erreur global
        wRes = await lastValueFrom(this.getRequestData(wRequest))
            .catch((error) => {
                console.log('getRequestList catch', error);
                return error;
            })
            .then((res: any) => {
                return res;
            });   

        if (!Array.isArray(wRes)) {
            this.checkTools.checkError(wRes);
            if (this.checkTools.getRes() === false) {
                console.log('getBasketDoc', this.checkTools.getMsgError());
                this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                return;
            }
        }
        // Tableau : verif statut individuel
        wRes.map((item) => {
            if (item.Status === 'OK') {
                this.docBasketList.push({
                    docid: item.doc_docid,
                    bsklist: item.basketlist.basket,
                    allowDelete: this.allowDelete(item.basketlist.basket),
                });
            }
        });
        this.verifyDel();
    }

    private getRequestData(aRequest) {
        return forkJoin(aRequest);
    }

    private verifyDel() {
        if (this.getAllowDelete() === false) {
            this.loadingService.resetLoader();
            this._messageService.addErrorNoStick(this.translate.instant('Del_KO'));
        } else {
            this.prepareList(this.selectedDocs);
        }
        this.closeIndex('validation');
    }

    private prepareList(aSelectedDocs) {
        let wDocList = new Array();
        if (this.bskMode === false) {
            wDocList = this.rightService.verifyRight(aSelectedDocs, 'TDel');
        } else {
            wDocList = [...this.selectedDocs];
        }

        if (wDocList.length === 0) {
            this._messageService.addErrorNoStick(this.translate.instant('Del_KO_1'));
        } else {
            this.deleteDoc(wDocList, aSelectedDocs.length - wDocList.length);
        }
    }

    private async deleteDoc(wDocList, aNbdoc) {
        let wRes: any;
        this.successList = [];
        this.failList = [];
        for (const item of wDocList) {
            this.requestTools.setCurrentDocId(item.doc_docid);
            wRes = await this.execClickDeleteDoc(item.doc_docid, item.doc_name, (callBack) => {
            });
        }
        this.endDelete(wDocList, aNbdoc);
    }

    private endDelete(aDocList, aNbdoc) {
        this.loadingService.resetLoader();
        if (aDocList.length === this.successList.length) {
            if (aNbdoc === 0) {
                this._messageService.addSuccess(this.translate.instant('Delete_OK'));
            } else {
                this._messageService.addWarnNoStick(this.translate.instant('Del_Right'));
            }
            this.endDeleteDoc({
                mode: this.bskMode,
                docidList: JSON.stringify(this.successList),
            });
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Delete_KO'));
        }
    }

    private async execClickDeleteDoc(aCurrentDocId, aCurrentDocName, callBack) {
        let wRes: any;
        wRes = false;
        // Verif lock
        wRes = await this.requestTools.execVerifyCheckOut(this.tokenService.login);
        if (wRes === false) {
            return;
        }
        wRes = false;
        this.formatRequestTools.clear(aCurrentDocId);
        wRes = await this.requestTools.execUpdate('checkin', this.formatRequestTools.checkin());
        if (wRes === false) {
            return;
        }        
        if (this.bskMode) {
            wRes = await this.execDeleteBasket(aCurrentDocId, aCurrentDocName);
        } else {
            wRes = await this.execDeleteGed(aCurrentDocId, aCurrentDocName);
        }
    }

    private async execDeleteBasket(aCurrentDocId, aCurrentDocName) {
        let wRes: any;
        let wInfoMail = new Object();
        let wAction = 'move';
        wRes = false;

        if (this.currentSelectedBsk.bskName === 'Deleted') {
            wInfoMail = {
                dstBasketName: this.currentSelectedBsk.bskName,
            };
            wAction = 'delete';
        } else {
            wInfoMail = {
                SrcBasketName: this.currentSelectedBsk.bskName,
                dstBasketName: 'Deleted',
            };
        }

        this.formatRequestTools.clear(aCurrentDocId);
        this.formatRequestTools.action = 'deletebsk';
        this.formatRequestTools.currentDocName = aCurrentDocName;
        let wRequest = this.formatRequestTools.deletebsk(wInfoMail);
        return await this.execBasket(wAction, wRequest, aCurrentDocId);
    }

    private async execBasket(aAction, aRequest, aDocId) {
        let wRes: any;
        wRes = false;
        wRes = await this.requestTools.execBasket(aAction, aRequest);
        this.updateList(wRes.status, aDocId);
        return wRes.status;
    }

    private async execDeleteGed(aCurrentDocId, aCurrentDocName) {
        let wRes: any;
        wRes = false;
        this.formatRequestTools.clear(aCurrentDocId);
        this.formatRequestTools.currentDocName = aCurrentDocName;
        let wRequest = this.formatRequestTools.deleteGed(this.archivDelete);
        wRes = await this.requestTools.execUpdate('deleteged', wRequest);
        this.updateList(wRes.status, aCurrentDocId);
        return wRes.status;
    }

    private getAllowDelete() {
        let wRes = true;
        if (this.actionGroup === false) {
            wRes = this.allowDelete(this.docBasket);
        } else {
            for (const item of this.docBasketList) {
                if (item.allowDelete === false) {
                    wRes = false;
                    break;
                }
            }
        }
        return wRes;
    }

    private allowDelete(aDocBasket) {
        let wRes = false;
        let wInBskDel: boolean;
        if (this.bskMode === false) {
            wInBskDel = this.inBskDeleted(aDocBasket);            
            if ((aDocBasket.length === 1 && wInBskDel) || aDocBasket.length === 0) {
                wRes = true;
            }
        } else {
            wRes = true;
        }
        return wRes;
    }

    // private allowDelete(aDocBasket) {
    //     let wRes = false;
    //     let wInBskDel: boolean;
    //     wInBskDel = this.inBskDeleted(aDocBasket);
    //     if (this.bskMode === false) {
    //         if ((aDocBasket.length === 1 && wInBskDel) || aDocBasket.length === 0) {
    //             wRes = true;
    //         }
    //     } else {
    //         if (wInBskDel === true) {
    //             if (aDocBasket.length === 1) {
    //                 wRes = true;
    //             }
    //         } else {
    //             wRes = true;
    //         }
    //     }
    //     return wRes;
    // }

    private inBskDeleted(aItem) {
        let wRes = false;
        for (const item of aItem) {
            if (item.name === 'Deleted') {
                wRes = true;
                break;
            }
        }
        return wRes;
    }

    private updateList(aRes, aDocid) {
        if (aRes === true) {
            this.successList.push(aDocid);
        } else {
            this.failList.push(aDocid);
        }
    }
}
